import Cookies from 'js-cookie';

const TokenKey = 'paysharp_client_access_token';
const RefreshKey = 'paysharp_client_refresh_token';
const AccountIndex = 'paysharp_account_index';
const activeModel = 'paysharp_active_model';
const LoginTypeIdKey = 'paysharp_client_login_typeid';
const TempTokenKey = 'paysharp_client_temp_token';
const ProductList = 'paysharp_product_list';

export function getAccessToken() {
  return Cookies.get(TokenKey);
  // return sessionStorage.getItem(TokenKey);
}

export function getTempToken() {
  return Cookies.get(TempTokenKey);
  // return sessionStorage.getItem(TempTokenKey);
}
export function setTempToken(token) {
  return Cookies.set(TempTokenKey, token, { secure: true, sameSite: 'strict' });
  // return sessionStorage.setItem(TempTokenKey, token);
}

export function getLoginTypeId() {
  return Cookies.get(LoginTypeIdKey);
  // return sessionStorage.getItem(LoginTypeIdKey);
}
export function setLoginTypeId(token) {
  return Cookies.set(LoginTypeIdKey, token, { secure: true, sameSite: 'strict' });
  // return sessionStorage.setItem(LoginTypeIdKey, token);
}

export function setAccessToken(token) {
  return Cookies.set(TokenKey, token, { secure: true, sameSite: 'strict' });
  // return sessionStorage.setItem(TokenKey, token);
}

export function setAccountIndex(accountIndex) {
  return Cookies.set(AccountIndex, accountIndex, { secure: true, sameSite: 'strict' });
  // return sessionStorage.setItem(AccountIndex, accountIndex);
}

export function setActiveModel(activeModelCode) {
  return Cookies.set(activeModel, activeModelCode, { secure: true, sameSite: 'strict' });
  
  // return sessionStorage.setItem(activeModel, activeModelCode);
}

export function setProductList(productList) {
  return Cookies.set(ProductList, productList, { secure: true,  sameSite: 'strict' });
  // return sessionStorage.setItem(ProductList, productList);
}
export function getProductList() {
  return Cookies.get(ProductList);
  // return sessionStorage.getItem(ProductList);
}


export function getActiveModel() {
  return Cookies.get(activeModel);
  // return sessionStorage.getItem(activeModel);
}
export function getAccountIndex() {
 return Cookies.get(AccountIndex);
  // return sessionStorage.getItem(AccountIndex);
}
export function removeActiveModel() {
  return Cookies.remove(activeModel);
  // return sessionStorage.removeItem(activeModel);
}
export function removeAccountIndex() {
  return Cookies.remove(AccountIndex);
  // return sessionStorage.removeItem(AccountIndex);
}

export function removeAccessToken() {
  return Cookies.remove(TokenKey);
  // return sessionStorage.removeItem(TokenKey);
}

export function removeTempToken() {
  return Cookies.remove(TempTokenKey);
  // return sessionStorage.removeItem(TempTokenKey);
}

export function removeLoginTypeId() {
  return Cookies.remove(LoginTypeIdKey);
  // return sessionStorage.removeItem(LoginTypeIdKey);
}
export function removeProductList() {
  return Cookies.remove(ProductList);
  // return sessionStorage.removeItem(ProductList);
}

// export function getRefreshToken() {
//   return Cookies.get(RefreshKey);
// }

// export function setRefreshToken(token) {
//   return Cookies.set(RefreshKey, token);
// }

// export function removeRefreshToken() {
//   return Cookies.remove(RefreshKey);
// }
